import {
  AUTO_DEMO_VOLUME,
  INITIAL_DEMO_VOLUME,
  LOCAL_STORAGE_KEY_DEMO_VOLUME,
  LOCAL_STORAGE_KEY_DEMO_VOLUME_CHOSEN,
} from '../../constants/sound';

/**
 * Громкость витрины главного меню.
 *
 * Значение живет в localStorage, потому что его читает не только React, но и
 * SoundManager напрямую (см. _getGlobalVolume) — именно по нему сцена решает,
 * грузить ли звуки вообще. Отсюда и отдельная отметка о выборе игрока: само
 * значение пишется и при автоподъеме громкости после загрузки поля, так что
 * по нему одному «игрок выбрал» от «выставили сами» не отличить.
 */
const readNumber = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    // localStorage недоступен (приватный режим и т.п.)
    return null;
  }
};

const write = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    // localStorage недоступен — просто не сохраняем
  }
};

/** Игрок сам двигал ползунок громкости витрины? */
export const checkIfDemoVolumeChosen = () => readNumber(LOCAL_STORAGE_KEY_DEMO_VOLUME_CHOSEN) === '1';

/**
 * Громкость, с которой витрина должна стартовать: выбор игрока, если он был,
 * иначе ноль — со звуком поле ждало бы загрузки всех звуков
 */
export const readDemoStartVolume = () => {
  if (!checkIfDemoVolumeChosen()) {
    return INITIAL_DEMO_VOLUME;
  }
  const stored = readNumber(LOCAL_STORAGE_KEY_DEMO_VOLUME);
  if (stored === null) return INITIAL_DEMO_VOLUME;
  const parsed = parseFloat(stored);
  if (Number.isNaN(parsed)) return INITIAL_DEMO_VOLUME;
  return Math.max(0, Math.min(1, parsed));
};

/** Громкость, которую витрина выставляет сама после загрузки поля */
export const getDemoAutoVolume = () => AUTO_DEMO_VOLUME;

/** Сохранить громкость (ее читает SoundManager), не помечая как выбор игрока */
export const saveDemoVolume = (volume) => {
  write(LOCAL_STORAGE_KEY_DEMO_VOLUME, String(volume));
};

/** Игрок подвинул ползунок: значение сохраняем и запоминаем сам факт выбора */
export const saveChosenDemoVolume = (volume) => {
  saveDemoVolume(volume);
  write(LOCAL_STORAGE_KEY_DEMO_VOLUME_CHOSEN, '1');
};
